export default "__VITE_ASSET__24283376__"